import {AppLayout} from "../../components/layouts/AppLayout"
import {useEffect, useState} from "react";
import {shortcutService} from "../../services/shortcut.service";
import {FullPageLoader} from "../../utils/FullPageLoader";
import {Toast} from "../../utils/Toast";
import {UrlConst} from "../../utils/url.-consts";
import {useHistory} from "react-router-dom";
import {ShortcutElement} from "../../components/shortcut/shortcutElement";

export const ShortCutsPage = () => {
    const [isLoading, setIsloading] = useState(true);
    const [myShortCuts, setMyShortCuts] = useState<any[]>([])
    const [fields, setFields] = useState<any[]>([])
    const history = useHistory();

    useEffect(() => {
        getMyShortCuts()
    }, [])

    const getMyShortCuts = async () => {
        const res: any = await shortcutService.getMyShortcuts('ALL')
        setIsloading(false)
        if (res.statusCode == 200) {
            setFields(res.payload.fieldValues)
            setMyShortCuts(res.payload.organizationShortcuts.records);
        } else {
            Toast.fire({
                icon: 'warning',
                title: res.message
            })
        }
    }

    return (
        <AppLayout>
            <div className="up-shortcutgrid">
                {isLoading && <FullPageLoader/>}
                <ShortcutElement shortCuts={myShortCuts} fields={fields} fullWidth={true}/>
            </div>
        </AppLayout>
    )
}